import { SearchControlsMobile } from "@modules/SearchControls/SearchControlsMobile";
import SearchFooter from "@modules/SearchControls/SearchFooter";
import SearchPagination from "@modules/SearchControls/SearchPagination";
import React, { Component, createRef } from "react";
import Overridable from "react-overridable";
import { Container, Ref, Sticky } from "semantic-ui-react";
import { EmptyResults, ResultsLoader, Error, withState } from "react-searchkit";
import PropTypes from "prop-types";
import { LiteratureSearchResultsGrid } from "@modules/Literature/LiteratureSearchResultsGrid";

// Mobile Results Component with State
const ThesisResultsMobileComponent = ({ currentResultsState }) => {
  const hits = currentResultsState?.data?.hits || [];
  return <LiteratureSearchResultsGrid results={hits} />;
};

ThesisResultsMobileComponent.propTypes = {
  currentResultsState: PropTypes.shape({
    data: PropTypes.shape({
      hits: PropTypes.array,
    }),
  }),
};

const ThesisResultsMobile = withState(ThesisResultsMobileComponent);

class ThesisSearchMobile extends Component {
  stickyRef = createRef();

  render() {
    return (
      <Overridable id="ThesisSearchMobile.layout" stickyRef={this.stickyRef}>
        <Container fluid className="grid-documents-search">
          <ResultsLoader>
            <EmptyResults />
            <Error />
            <Ref innerRef={this.stickyRef}>
              <Container fluid>
                <Overridable id="ThesisSearchMobile.Controls">
                  <>
                    <Sticky context={this.stickyRef} offset={66}>
                      <SearchControlsMobile
                        ref={this.stickyRef}
                        modelName="SPECIAL_COLLECTIONS"
                      />
                    </Sticky>
                    <Container textAlign="center">
                      <SearchPagination />
                    </Container>
                  </>
                </Overridable>

                <Overridable id="ThesisSearchMobile.Body">
                  <Container className="fs-search-body" textAlign="center">
                    <ThesisResultsMobile />
                    <Overridable id="ThesisSearchMobile.Footer">
                      <Container fluid className="search-results-footer">
                        <SearchFooter />
                      </Container>
                    </Overridable>
                  </Container>
                </Overridable>
              </Container>
            </Ref>
          </ResultsLoader>
        </Container>
      </Overridable>
    );
  }
}

export default Overridable.component("ThesisSearchMobile", ThesisSearchMobile);
